var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("top-table", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          sortable: _vm.sortable,
          url: _vm.url,
          overlap: false,
          onLoadData: _vm.onLoadData,
          requestFunction: _vm.requestFunc,
        },
        scopedSlots: _vm._u([
          {
            key: "supplier",
            fn: function (props) {
              return [
                props.row?.allEQPSuppliers
                  ? _c("span", [_vm._v(" All suppliers marked as EQP ")])
                  : _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            props.row?.supplier
                              ? props.row?.supplier?.name
                              : props.row?.name || ""
                          ) +
                          "\n        "
                      ),
                      props.row?.productsCount
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "badge badge-info ml-2",
                              attrs: { title: "Available Products" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(props.row?.productsCount) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c("span", { staticClass: "badge badge-info ml-2" }, [
                            _vm._v("No Available Products"),
                          ]),
                    ]),
              ]
            },
          },
          {
            key: "categories",
            fn: function (props) {
              return [
                _vm._v(
                  _vm._s(props.row?.categories?.map((e) => e.name).join(", "))
                ),
              ]
            },
          },
          {
            key: "facets",
            fn: function (props) {
              return [
                _vm._v(
                  _vm._s(props.row?.facets?.map((e) => e.name).join(", "))
                ),
              ]
            },
          },
          {
            key: "actions",
            fn: function (props) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    !props.row?.isNotIncluded
                      ? _c("FormModal", {
                          key: props.row.updatedAt,
                          attrs: { item: props.row, hideRule: true },
                          on: { change: _vm.onChange },
                        })
                      : _vm._e(),
                    !props.row?.isNotIncluded
                      ? _c("delete-button", {
                          attrs: {
                            title: props.row?.supplier?.name
                              ? props.row?.supplier?.name
                              : props.row?.name || "-",
                            record: props.row,
                            remove: () => _vm.remove(props),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "customAfterFilter",
            fn: function (props) {
              return [
                _c(
                  "div",
                  { staticClass: "ml-2 mt-4" },
                  [
                    _c("FormModal", {
                      attrs: {
                        hideRule: true,
                        hasSupplierExclusions: _vm.hasSupplierExclusions,
                        item: {
                          categories: [],
                          facets: [],
                          supplier: null,
                          mode: _vm.isExcludeMode ? 1 : 2,
                        },
                      },
                      on: { change: _vm.onChange },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }